import portaro from '../portaro';
import {getErrorMessage, getRecordPath, getRecordUrlId} from 'shared/utils/data-service-utils';
import KpVisitedPanel from '../commons/components/kp-visited-panel/KpVisitedPanel.svelte';
import KpPluralizeText from '../commons/components/kp-pluralize-text/KpPluralizeText.svelte';
import KpFavouritesPanel from '../commons/components/kp-favourites-panel/KpFavouritesPanel.svelte';
import KpRecordClipboardPanel
    from '../commons/components/record-clipboard/kp-record-clipboard-panel/KpRecordCliboardPanel.svelte';
import KpSearchSorting from './components/kp-search-sorting/KpSearchSorting.svelte';
import KpSearchFacets from '../commons/components/kp-search-facets/KpSearchFacets.svelte';
import KpSearchAdditionalFilters from './components/kp-search-additional-filters/KpSearchAdditionalFilters.svelte';
import {isEqual} from 'lodash';

portaro.directive('jpSearch', ['CONTEXT_PATH', 'TEMPLATES_PATH', 'currentAuth', 'sdiRequestsDataService', 'searchService', 'searchManagerFactory', 'favouritesCollectionService', '$anchorScroll', '$log', 'finishedResponseInteractionService', 'walker', 'cancellationDataService', 'localizationService', 'toasterService', 'messageDataService', 'loginService',
    function (/* string */ CONTEXT_PATH,
              /* string */ TEMPLATES_PATH,
              /* Auth */ currentAuth,
              /* SdiRequestsDataService */ sdiRequestsDataService,
              /* SearchService */ searchService,
              /* SearchManagerFactory */ searchManagerFactory,
              /* FavouritesCollectionService */ favouritesCollectionService,
              /* IAnchorScrollService */ $anchorScroll,
              /* ILogService */ $log,
              /* FinishedResponseInteractionService */ finishedResponseInteractionService,
              /* WalkerService */ walker,
              /* CancellationDataService */ cancellationDataService,
              /* LocalizationService */ localizationService,
              /* ToasterService */ toasterService,
              /* MessageDataService */ messageDataService,
              /* LoginService */ loginService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATES_PATH + 'jp-search.html',
            scope: {
                staticParams: '=?',
                searchManager: '=?'
            },
            link: function ($scope) {
                $scope.CONTEXT_PATH = CONTEXT_PATH;
                $scope.TEMPLATES_PATH = TEMPLATES_PATH;
                $scope.currentAuth = currentAuth;
                $scope.kpVisitedPanelComponent = KpVisitedPanel;
                $scope.kpPluralizeTextComponent = KpPluralizeText;
                $scope.kpFavouritesPanelComponent = KpFavouritesPanel;
                $scope.kpRecordClipboardPanelComponent = KpRecordClipboardPanel;
                $scope.kpSearchSortingComponent = KpSearchSorting;
                $scope.kpSearchFacetsComponent = KpSearchFacets;
                $scope.kpSearchAdditionalFiltersComponent = KpSearchAdditionalFilters;

                if (!$scope.searchManager) {
                    const searchFunction = (params) => {
                        return searchService.search(params)
                            .then(function (search) {
                                search.result.content
                                    .filter(record => record.type === 'document')
                                    .forEach((record) => favouritesCollectionService.registerPotential(record));
                                return search;
                            })
                            .catch(function (res) {
                                $log.error(getErrorMessage(res));
                                return Promise.reject(res);
                            });
                    }

                    $scope.searchManager = searchManagerFactory.createGlobalSearch(searchFunction, $scope.staticParams);
                }

                // po prvnim pridani do oblibenych zascrolujeme do panelu
                const listenForFavouritesChanges = (favourites) => {
                    const subscription = favourites
                        .getCollectionUpdateEvent$()
                        .subscribe((event) => {
                            if (event.type === 'insert' && favourites.getSize() === 1) {
                                $anchorScroll('favourites-panel');
                            }
                        })

                    $scope.$on('$destroy', () => subscription.unsubscribe());
                }

                favouritesCollectionService
                    .getFavouritesCollectionManager()
                    .then((favourites) => listenForFavouritesChanges(favourites))


                $scope.facetRestrictionChanged = function (restriction) {
                    $scope.searchManager.params().facetRestriction = restriction;
                    $scope.newSearch();
                };


                $scope.onPageSizeChange = function (newPageSize) {
                    $scope.searchManager.params().pageSize = newPageSize;
                    $scope.newSearch();
                };


                $scope.newSearch = function () {
                    favouritesCollectionService.clearPotentials();
                    $scope.searchManager.newSearch();
                };


                $scope.newSearchWithParams = function (newParams) {
                    favouritesCollectionService.clearPotentials();
                    $scope.searchManager.newSearchWithParams(newParams);
                };

                let kpSearchAdditionalFiltersComponentProps = {};
                // TODO: remove this function when refactoring to svelte
                // this is hack to make it work in angular
                // if new props object is created every time then it crashes angular due to the digest cycle loop
                // if props is const object and its properties are mutated then angular does not detect changes
                // => we need to detect changes ourself and cache most current props
                // god help me :-(
                $scope.getSearchFiltersComponentProps = (filters, params) => {
                    const newProps = {filters, params};
                    if (!isEqual(kpSearchAdditionalFiltersComponentProps, newProps)) {
                        kpSearchAdditionalFiltersComponentProps = newProps;
                    }
                    return kpSearchAdditionalFiltersComponentProps;
                }

                $scope.addSdiRequest = async function () {
                    try {
                        await loginService.login();
                        const response = await sdiRequestsDataService.createSdiRequest({search: $scope.searchManager.lastSearch(), user: currentAuth.activeUser});
                        await finishedResponseInteractionService.showSuccessResponseInToastIfPossible(response);
                    } catch (exceptionResponse) {
                        finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
                    }
                };

                $scope.goToRecord = function (record) {
                    walker.newPageOnContext(getRecordPath(getRecordUrlId(record)));
                }

                $scope.$on("$destroy", function () {
                    favouritesCollectionService.clearPotentials();
                    $scope.searchManager.destroy();
                });

                $scope.cancelLoan = async (loan) => {
                    await cancellationDataService.cancelLoan(loan);
                    $scope.searchManager.newSearch(); // FIXME: pri vicenasobnem mazani se seznam refreshne jen po prvnim mazani
                    toasterService.showSuccess(localizationService.get(/* @kp-localization commons.HasBeenDeleted */ 'commons.HasBeenDeleted'));
                };

                $scope.loadMessageSendings = (messageId) => {
                    return messageDataService.getMessageSendings(messageId);
                };
            }
        };
    }]);